import { useMutation } from '@tanstack/react-query';
import { deleteClinicMasterProduct } from '../requests';
import { useRemoveCachedClinicMasterProducts } from './useClinicMasterProducts';

type DeleteClinicMasterProduct = (id: string) => Promise<void>;

interface UseDeleteClinicMasterProductReturn {
  deleteClinicMasterProduct: DeleteClinicMasterProduct;
  isLoading: boolean;
}

export const useDeleteClinicMasterProduct = (): UseDeleteClinicMasterProductReturn => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: (id: string) => deleteClinicMasterProduct(id)
  });
  const removeCache = useRemoveCachedClinicMasterProducts();

  const deleteClinicMasterProductCallback = async (id: string) => {
    const response = await mutateAsync(id);
    removeCache();
    return response.data.data;
  };

  return {
    deleteClinicMasterProduct: deleteClinicMasterProductCallback,
    isLoading
  };
};
